import React from "react"
import Link from "../UI/Link/Link"
import { get } from "../../helpers/utils"
import * as styles from "./PressRelease-tw-styles"
import PropTypes from "prop-types"
import useScreenSize from "../../hooks/useScreenSize"
import {
  TOP_BUTTON,
  PRESSRELEASE_VARIENT,
  PRESSRELEASE_VARIENT_NOTAB,
  NULL,
  UNDEFINED,
} from "../../constants/label.constants"
import {
  gaEventClick,
  gaExternalLink,
  gaInternalLink,
} from "../../constants/gtm.constants"

const PressRelease = props => {
  const { variant, listOfReleasesCollection, linkOfYearCollection, isYear } =
    props
  const style = styles[variant] || styles.defaultStyle
  const screen = useScreenSize()
  const {
    containerDiv,
    timeTab,
    yearsDiv,
    dateTime,
    timeStyle,
    yearButton,
    yearFlex,
    links,
    linksWrapper,
    yearRelease,
    timeTabWrapper,
    timeTabWrap,
    topLink,
    topText,
    yearButtonInactive,
    yearReleaseDiv,
    yearReleaseContainer,
  } = style
  const listOfReleases = get(listOfReleasesCollection, "items", [])
  const Tabyear = get(linkOfYearCollection, "items", [])
  let listofyears = listOfReleases?.reduce((press, data) => {
    const date = data?.year

    press[date] = !press[date] ? [] : press[date]

    press[date].push(data)

    return press
  }, {})
  const years = Object.keys(listofyears || {})
  years.sort((a, b) => b - a)
  return (
    <div id={"main"} className={containerDiv}>
      {(screen?.isDesktop || screen?.isTablet) && (
        <div className={topLink}>
          {" "}
          <Link
            scrollToElementId="main"
            gaEventLabel={TOP_BUTTON}
            className={gaEventClick}
          >
            {" "}
            <p className={topText}> {TOP_BUTTON} </p>
          </Link>{" "}
        </div>
      )}
      {(screen?.isDesktop || screen?.isTablet) && (
        <div className={timeTabWrapper}>
          <div className={timeTabWrap}>
            <div className={timeTab}>
              {variant == PRESSRELEASE_VARIENT_NOTAB
                ? ""
                : variant === PRESSRELEASE_VARIENT
                ? Tabyear?.length > 1 &&
                  Tabyear.map((years, index) => {
                    return (
                      <div key={index} className={yearFlex}>
                        {years === NULL || years === UNDEFINED ? (
                          " "
                        ) : (
                          <Link
                            ariaLabel="Year"
                            url={years.url}
                            target="_self"
                            className={
                              typeof window !== "undefined" &&
                              window.location.pathname === years.url
                                ? `${yearButtonInactive} ${gaInternalLink}`
                                : `${yearButton} ${gaInternalLink}`
                            }
                            gaEventLabel={`#${years.label}`}
                          >
                            {years.label}{" "}
                          </Link>
                        )}
                      </div>
                    )
                  })
                : years?.length > 1 &&
                  years?.map((year, index) => {
                    return (
                      <div key={index} className={yearFlex}>
                        {year === NULL || year === UNDEFINED ? (
                          ""
                        ) : (
                          <Link
                            ariaLabel="Year"
                            scrollToElementId={year}
                            target="_self"
                            className={`${yearButton} ${gaInternalLink}`}
                            gaEventLabel={`#${year}`}
                          >
                            {year}{" "}
                          </Link>
                        )}
                      </div>
                    )
                  })}
            </div>
          </div>
        </div>
      )}
      <div className={yearsDiv}>
        {years &&
          years?.map((year, idx) => (
            <div key={idx} className={yearReleaseContainer}>
              <div id={year} className={yearReleaseDiv}>
                {" "}
                {isYear === false ? (
                  " "
                ) : year === NULL || year === UNDEFINED ? (
                  " "
                ) : (
                  <h1 className={yearRelease}>{year} </h1>
                )}
              </div>
              {listofyears &&
                listofyears[year]?.map((release, index) => {
                  return (
                    <div className={dateTime} key={index}>
                      {release?.dates && (
                        <div className={timeStyle}>{release?.dates}</div>
                      )}
                      <div className={linksWrapper}>
                        {
                          <Link
                            ariaLabel={
                              release?.pdf === null
                                ? release?.url?.title
                                : release?.pdf?.title
                            }
                            className={`${links} ${gaExternalLink}`}
                            gaEventLabel={release?.pdf?.url}
                            target="_blank"
                            url={
                              release?.pdf === null
                                ? release?.url?.url
                                : release?.pdf?.url
                            }
                          >
                            {release?.pdf === null
                              ? release?.url?.title
                              : release?.pdf?.title}
                          </Link>
                        }
                        {release?.pdfLink && (
                          <Link
                            url={release?.pdfLink?.newLink}
                            ariaLabel={release?.pdfLink?.title}
                            gaEventLabel={release?.pdfLink?.newLink}
                            target={release?.pdfLink?.target}
                            className={`${links} ${gaExternalLink}`}
                          >
                            {release?.pdfLink?.title}
                          </Link>
                        )}
                      </div>
                    </div>
                  )
                })}
            </div>
          ))}
      </div>
    </div>
  )
}
PressRelease.propTypes = {
  listOfReleasesCollection: PropTypes.array,
  variant: PropTypes.string,
  linkOfYearCollection: PropTypes.object,
  isYear: PropTypes.bool,
}

export default PressRelease
